/* tslint:disable */
/* eslint-disable */
/**
 * TOM PLANNING SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AllowOrderPassageCommand } from '../model';
// @ts-ignore
import type { AllowRestowOrderPassageCommand } from '../model';
// @ts-ignore
import type { AssignOrderToRailcarTrackPositionCommand } from '../model';
// @ts-ignore
import type { CarrierType } from '../model';
// @ts-ignore
import type { CarrierVisitDirection } from '../model';
// @ts-ignore
import type { ConfirmActualCargoAmountOrderCommand } from '../model';
// @ts-ignore
import type { ContainerJourneyDto } from '../model';
// @ts-ignore
import type { CreateOrAssignOrderToRailcarTrackPositionCommand } from '../model';
// @ts-ignore
import type { CreateOrdersCommand } from '../model';
// @ts-ignore
import type { FirstAvailableOrderInGroupDto } from '../model';
// @ts-ignore
import type { GetFirstAvailableOrderInGroupQuery } from '../model';
// @ts-ignore
import type { GetOrderUpdatesByOrderIdsQuery } from '../model';
// @ts-ignore
import type { GetOrdersByIdsQuery } from '../model';
// @ts-ignore
import type { MarkOrderUpdatesAsReadCommand } from '../model';
// @ts-ignore
import type { OrderResponseDto } from '../model';
// @ts-ignore
import type { OrderStatus } from '../model';
// @ts-ignore
import type { OrderUpdateResponseDto } from '../model';
// @ts-ignore
import type { PickUpOrderFilterType } from '../model';
// @ts-ignore
import type { ReleaseOrderDtoPaginatedList } from '../model';
// @ts-ignore
import type { RemoveOrFinishOpenOrdersCommand } from '../model';
// @ts-ignore
import type { ReportOrderShortlandedCommand } from '../model';
// @ts-ignore
import type { SyncOrdersDto } from '../model';
// @ts-ignore
import type { TestUpdateCustomsStatusCommand } from '../model';
// @ts-ignore
import type { TruckAppointmentOrderDtoPaginatedList } from '../model';
// @ts-ignore
import type { UpdateCustomerSequenceCommand } from '../model';
// @ts-ignore
import type { UpdateCustomsStatusCommand } from '../model';
// @ts-ignore
import type { UpdateOrderCommand } from '../model';
// @ts-ignore
import type { UpdateOrderStowagePositionCommand } from '../model';
// @ts-ignore
import type { UpdateOrderWeightCommand } from '../model';
// @ts-ignore
import type { UpdateReleaseOrdersCommand } from '../model';
/**
 * OrdersApi - axios parameter creator
 */
export const OrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {boolean} [deleteLinkedOrders] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        _delete: async (id: number, deleteLinkedOrders?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('_delete', 'id', id)
            const localVarPath = `/planning/api/Orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (deleteLinkedOrders !== undefined) {
                localVarQueryParameter['deleteLinkedOrders'] = deleteLinkedOrders;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfirmActualCargoAmountOrderCommand} [confirmActualCargoAmountOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actualCargoAmount: async (id: number, confirmActualCargoAmountOrderCommand?: ConfirmActualCargoAmountOrderCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('actualCargoAmount', 'id', id)
            const localVarPath = `/planning/api/Orders/{id}/ActualCargoAmount`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(confirmActualCargoAmountOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AllowOrderPassageCommand} [allowOrderPassageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allowPassage: async (allowOrderPassageCommand?: AllowOrderPassageCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Orders/AllowPassage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(allowOrderPassageCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AllowRestowOrderPassageCommand} [allowRestowOrderPassageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allowRestowPassage: async (allowRestowOrderPassageCommand?: AllowRestowOrderPassageCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Orders/AllowRestowPassage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(allowRestowOrderPassageCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateReleaseOrdersCommand} [updateReleaseOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignToRailcar: async (updateReleaseOrdersCommand?: UpdateReleaseOrdersCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Orders/AssignToRailcar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReleaseOrdersCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AssignOrderToRailcarTrackPositionCommand} [assignOrderToRailcarTrackPositionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignToRailcarTrackPosition: async (assignOrderToRailcarTrackPositionCommand?: AssignOrderToRailcarTrackPositionCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Orders/AssignToRailcarTrackPosition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignOrderToRailcarTrackPositionCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {boolean} [includeRestow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerJourney: async (filter?: string, includeRestow?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Orders/ContainerJourney`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (filter !== undefined) {
                localVarQueryParameter['Filter'] = filter;
            }

            if (includeRestow !== undefined) {
                localVarQueryParameter['IncludeRestow'] = includeRestow;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateOrAssignOrderToRailcarTrackPositionCommand} [createOrAssignOrderToRailcarTrackPositionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrAssignToRailcarTrackPosition: async (createOrAssignOrderToRailcarTrackPositionCommand?: CreateOrAssignOrderToRailcarTrackPositionCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Orders/CreateOrAssignToRailcarTrackPosition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrAssignOrderToRailcarTrackPositionCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateCustomerSequenceCommand} [updateCustomerSequenceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerSequence: async (updateCustomerSequenceCommand?: UpdateCustomerSequenceCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Orders/CustomerSequence`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCustomerSequenceCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {OrderStatus} [orderStatus] 
         * @param {boolean} [includeCompleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveries: async (filter?: string, orderStatus?: OrderStatus, includeCompleted?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Orders/Deliveries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (filter !== undefined) {
                localVarQueryParameter['Filter'] = filter;
            }

            if (orderStatus !== undefined) {
                localVarQueryParameter['OrderStatus'] = orderStatus;
            }

            if (includeCompleted !== undefined) {
                localVarQueryParameter['IncludeCompleted'] = includeCompleted;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dropOffOrders: async (filter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Orders/DropOffOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (filter !== undefined) {
                localVarQueryParameter['Filter'] = filter;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetFirstAvailableOrderInGroupQuery} [getFirstAvailableOrderInGroupQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firstAvailableOrderInGroups: async (getFirstAvailableOrderInGroupQuery?: GetFirstAvailableOrderInGroupQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Orders/FirstAvailableOrderInGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getFirstAvailableOrderInGroupQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} referenceNumber 
         * @param {string} operator 
         * @param {number} carrierVisitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookings: async (referenceNumber: string, operator: string, carrierVisitId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'referenceNumber' is not null or undefined
            assertParamExists('getBookings', 'referenceNumber', referenceNumber)
            // verify required parameter 'operator' is not null or undefined
            assertParamExists('getBookings', 'operator', operator)
            // verify required parameter 'carrierVisitId' is not null or undefined
            assertParamExists('getBookings', 'carrierVisitId', carrierVisitId)
            const localVarPath = `/planning/api/Orders/GetBookings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (referenceNumber !== undefined) {
                localVarQueryParameter['ReferenceNumber'] = referenceNumber;
            }

            if (operator !== undefined) {
                localVarQueryParameter['Operator'] = operator;
            }

            if (carrierVisitId !== undefined) {
                localVarQueryParameter['CarrierVisitId'] = carrierVisitId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} filter 
         * @param {OrderStatus} [status] 
         * @param {boolean} [includeRestow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByContainerNumber: async (filter: string, status?: OrderStatus, includeRestow?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filter' is not null or undefined
            assertParamExists('getByContainerNumber', 'filter', filter)
            const localVarPath = `/planning/api/Orders/containerNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (filter !== undefined) {
                localVarQueryParameter['Filter'] = filter;
            }

            if (status !== undefined) {
                localVarQueryParameter['Status'] = status;
            }

            if (includeRestow !== undefined) {
                localVarQueryParameter['IncludeRestow'] = includeRestow;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getById', 'id', id)
            const localVarPath = `/planning/api/Orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetOrdersByIdsQuery} [getOrdersByIdsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds: async (getOrdersByIdsQuery?: GetOrdersByIdsQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Orders/GetByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getOrdersByIdsQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} filter 
         * @param {CarrierVisitDirection} direction 
         * @param {CarrierType} [carrierType] 
         * @param {OrderStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByReferenceNumber: async (filter: string, direction: CarrierVisitDirection, carrierType?: CarrierType, status?: OrderStatus, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filter' is not null or undefined
            assertParamExists('getByReferenceNumber', 'filter', filter)
            // verify required parameter 'direction' is not null or undefined
            assertParamExists('getByReferenceNumber', 'direction', direction)
            const localVarPath = `/planning/api/Orders/referenceNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (filter !== undefined) {
                localVarQueryParameter['Filter'] = filter;
            }

            if (direction !== undefined) {
                localVarQueryParameter['Direction'] = direction;
            }

            if (carrierType !== undefined) {
                localVarQueryParameter['CarrierType'] = carrierType;
            }

            if (status !== undefined) {
                localVarQueryParameter['Status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetOrderUpdatesByOrderIdsQuery} [getOrderUpdatesByOrderIdsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadUpdatesByOrderIds: async (getOrderUpdatesByOrderIdsQuery?: GetOrderUpdatesByOrderIdsQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Orders/GetUnreadUpdatesByOrderIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getOrderUpdatesByOrderIdsQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MarkOrderUpdatesAsReadCommand} [markOrderUpdatesAsReadCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markOrderUpdatesAsRead: async (markOrderUpdatesAsReadCommand?: MarkOrderUpdatesAsReadCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Orders/MarkOrderUpdatesAsRead`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markOrderUpdatesAsReadCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {PickUpOrderFilterType} [filterBy] 
         * @param {boolean} [includeRestow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pickUpOrders: async (filter?: string, filterBy?: PickUpOrderFilterType, includeRestow?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Orders/PickUpOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (filter !== undefined) {
                localVarQueryParameter['Filter'] = filter;
            }

            if (filterBy !== undefined) {
                localVarQueryParameter['FilterBy'] = filterBy;
            }

            if (includeRestow !== undefined) {
                localVarQueryParameter['IncludeRestow'] = includeRestow;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateOrdersCommand} [createOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post: async (createOrdersCommand?: CreateOrdersCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrdersCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateOrderCommand} [updateOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        put: async (updateOrderCommand?: UpdateOrderCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {OrderStatus} [orderStatus] 
         * @param {string} [filter] 
         * @param {boolean} [includeCompleted] 
         * @param {string} [orderBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseOrders: async (page: number, pageSize: number, orderStatus?: OrderStatus, filter?: string, includeCompleted?: boolean, orderBy?: string, isDescending?: boolean, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('releaseOrders', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('releaseOrders', 'pageSize', pageSize)
            const localVarPath = `/planning/api/Orders/releases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (orderStatus !== undefined) {
                localVarQueryParameter['OrderStatus'] = orderStatus;
            }

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (filter !== undefined) {
                localVarQueryParameter['Filter'] = filter;
            }

            if (includeCompleted !== undefined) {
                localVarQueryParameter['IncludeCompleted'] = includeCompleted;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['OrderBy'] = orderBy;
            }

            if (isDescending !== undefined) {
                localVarQueryParameter['IsDescending'] = isDescending;
            }

            if (from !== undefined) {
                localVarQueryParameter['From'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['To'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RemoveOrFinishOpenOrdersCommand} [removeOrFinishOpenOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOrFinishOpenOrders: async (removeOrFinishOpenOrdersCommand?: RemoveOrFinishOpenOrdersCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Orders/RemoveOrFinishOpenOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeOrFinishOpenOrdersCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportOrderShortlandedCommand} [reportOrderShortlandedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportShortlandedContainer: async (reportOrderShortlandedCommand?: ReportOrderShortlandedCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Orders/ReportShortlandedContainer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportOrderShortlandedCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [from] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        sync: async (from?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Orders/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TestUpdateCustomsStatusCommand} [testUpdateCustomsStatusCommand] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        testUpdateCustomsStatus: async (testUpdateCustomsStatusCommand?: TestUpdateCustomsStatusCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Orders/TestUpdateCustomsStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testUpdateCustomsStatusCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {CarrierVisitDirection} [direction] 
         * @param {string} [filter] 
         * @param {boolean} [includeCompleted] 
         * @param {string} [orderBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        truckAppointmentOrders: async (page: number, pageSize: number, direction?: CarrierVisitDirection, filter?: string, includeCompleted?: boolean, orderBy?: string, isDescending?: boolean, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('truckAppointmentOrders', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('truckAppointmentOrders', 'pageSize', pageSize)
            const localVarPath = `/planning/api/Orders/truck-appointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (direction !== undefined) {
                localVarQueryParameter['Direction'] = direction;
            }

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (filter !== undefined) {
                localVarQueryParameter['Filter'] = filter;
            }

            if (includeCompleted !== undefined) {
                localVarQueryParameter['IncludeCompleted'] = includeCompleted;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['OrderBy'] = orderBy;
            }

            if (isDescending !== undefined) {
                localVarQueryParameter['IsDescending'] = isDescending;
            }

            if (from !== undefined) {
                localVarQueryParameter['From'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['To'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateCustomsStatusCommand} [updateCustomsStatusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomsStatus: async (updateCustomsStatusCommand?: UpdateCustomsStatusCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Orders/UpdateCustomsStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCustomsStatusCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateReleaseOrdersCommand} [updateReleaseOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrdersReleaseTime: async (updateReleaseOrdersCommand?: UpdateReleaseOrdersCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Orders/UpdateOrdersReleaseTime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReleaseOrdersCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateOrderStowagePositionCommand} [updateOrderStowagePositionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStowagePosition: async (id: number, updateOrderStowagePositionCommand?: UpdateOrderStowagePositionCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateStowagePosition', 'id', id)
            const localVarPath = `/planning/api/Orders/{id}/updateStowagePosition`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrderStowagePositionCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [containerNumbers] 
         * @param {number} [destinationCarrierVisitId] 
         * @param {CarrierVisitDirection} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateMoveOrdersToCarrierVisitQuery: async (containerNumbers?: Array<string>, destinationCarrierVisitId?: number, direction?: CarrierVisitDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/Orders/ValidateMoveOrdersToCarrierVisitQuery`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (containerNumbers) {
                localVarQueryParameter['ContainerNumbers'] = containerNumbers;
            }

            if (destinationCarrierVisitId !== undefined) {
                localVarQueryParameter['DestinationCarrierVisitId'] = destinationCarrierVisitId;
            }

            if (direction !== undefined) {
                localVarQueryParameter['Direction'] = direction;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateOrderWeightCommand} [updateOrderWeightCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weight: async (id: number, updateOrderWeightCommand?: UpdateOrderWeightCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('weight', 'id', id)
            const localVarPath = `/planning/api/Orders/{id}/Weight`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrderWeightCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrdersApi - functional programming interface
 */
export const OrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {boolean} [deleteLinkedOrders] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async _delete(id: number, deleteLinkedOrders?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(id, deleteLinkedOrders, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi._delete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfirmActualCargoAmountOrderCommand} [confirmActualCargoAmountOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actualCargoAmount(id: number, confirmActualCargoAmountOrderCommand?: ConfirmActualCargoAmountOrderCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actualCargoAmount(id, confirmActualCargoAmountOrderCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.actualCargoAmount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AllowOrderPassageCommand} [allowOrderPassageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allowPassage(allowOrderPassageCommand?: AllowOrderPassageCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allowPassage(allowOrderPassageCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.allowPassage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AllowRestowOrderPassageCommand} [allowRestowOrderPassageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allowRestowPassage(allowRestowOrderPassageCommand?: AllowRestowOrderPassageCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allowRestowPassage(allowRestowOrderPassageCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.allowRestowPassage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateReleaseOrdersCommand} [updateReleaseOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignToRailcar(updateReleaseOrdersCommand?: UpdateReleaseOrdersCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignToRailcar(updateReleaseOrdersCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.assignToRailcar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AssignOrderToRailcarTrackPositionCommand} [assignOrderToRailcarTrackPositionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignToRailcarTrackPosition(assignOrderToRailcarTrackPositionCommand?: AssignOrderToRailcarTrackPositionCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignToRailcarTrackPosition(assignOrderToRailcarTrackPositionCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.assignToRailcarTrackPosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {boolean} [includeRestow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerJourney(filter?: string, includeRestow?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContainerJourneyDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerJourney(filter, includeRestow, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.containerJourney']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateOrAssignOrderToRailcarTrackPositionCommand} [createOrAssignOrderToRailcarTrackPositionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrAssignToRailcarTrackPosition(createOrAssignOrderToRailcarTrackPositionCommand?: CreateOrAssignOrderToRailcarTrackPositionCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrAssignToRailcarTrackPosition(createOrAssignOrderToRailcarTrackPositionCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.createOrAssignToRailcarTrackPosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateCustomerSequenceCommand} [updateCustomerSequenceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerSequence(updateCustomerSequenceCommand?: UpdateCustomerSequenceCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerSequence(updateCustomerSequenceCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.customerSequence']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {OrderStatus} [orderStatus] 
         * @param {boolean} [includeCompleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveries(filter?: string, orderStatus?: OrderStatus, includeCompleted?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrderResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveries(filter, orderStatus, includeCompleted, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.deliveries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dropOffOrders(filter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrderResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dropOffOrders(filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.dropOffOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetFirstAvailableOrderInGroupQuery} [getFirstAvailableOrderInGroupQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async firstAvailableOrderInGroups(getFirstAvailableOrderInGroupQuery?: GetFirstAvailableOrderInGroupQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FirstAvailableOrderInGroupDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.firstAvailableOrderInGroups(getFirstAvailableOrderInGroupQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.firstAvailableOrderInGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} referenceNumber 
         * @param {string} operator 
         * @param {number} carrierVisitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookings(referenceNumber: string, operator: string, carrierVisitId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrderResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookings(referenceNumber, operator, carrierVisitId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getBookings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} filter 
         * @param {OrderStatus} [status] 
         * @param {boolean} [includeRestow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByContainerNumber(filter: string, status?: OrderStatus, includeRestow?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrderResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByContainerNumber(filter, status, includeRestow, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getByContainerNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetOrdersByIdsQuery} [getOrdersByIdsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByIds(getOrdersByIdsQuery?: GetOrdersByIdsQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrderResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByIds(getOrdersByIdsQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getByIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} filter 
         * @param {CarrierVisitDirection} direction 
         * @param {CarrierType} [carrierType] 
         * @param {OrderStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByReferenceNumber(filter: string, direction: CarrierVisitDirection, carrierType?: CarrierType, status?: OrderStatus, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrderResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByReferenceNumber(filter, direction, carrierType, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getByReferenceNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetOrderUpdatesByOrderIdsQuery} [getOrderUpdatesByOrderIdsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnreadUpdatesByOrderIds(getOrderUpdatesByOrderIdsQuery?: GetOrderUpdatesByOrderIdsQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrderUpdateResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnreadUpdatesByOrderIds(getOrderUpdatesByOrderIdsQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.getUnreadUpdatesByOrderIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MarkOrderUpdatesAsReadCommand} [markOrderUpdatesAsReadCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markOrderUpdatesAsRead(markOrderUpdatesAsReadCommand?: MarkOrderUpdatesAsReadCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markOrderUpdatesAsRead(markOrderUpdatesAsReadCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.markOrderUpdatesAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {PickUpOrderFilterType} [filterBy] 
         * @param {boolean} [includeRestow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pickUpOrders(filter?: string, filterBy?: PickUpOrderFilterType, includeRestow?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrderResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pickUpOrders(filter, filterBy, includeRestow, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.pickUpOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateOrdersCommand} [createOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async post(createOrdersCommand?: CreateOrdersCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.post(createOrdersCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.post']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateOrderCommand} [updateOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async put(updateOrderCommand?: UpdateOrderCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.put(updateOrderCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.put']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {OrderStatus} [orderStatus] 
         * @param {string} [filter] 
         * @param {boolean} [includeCompleted] 
         * @param {string} [orderBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async releaseOrders(page: number, pageSize: number, orderStatus?: OrderStatus, filter?: string, includeCompleted?: boolean, orderBy?: string, isDescending?: boolean, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReleaseOrderDtoPaginatedList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.releaseOrders(page, pageSize, orderStatus, filter, includeCompleted, orderBy, isDescending, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.releaseOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RemoveOrFinishOpenOrdersCommand} [removeOrFinishOpenOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeOrFinishOpenOrders(removeOrFinishOpenOrdersCommand?: RemoveOrFinishOpenOrdersCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeOrFinishOpenOrders(removeOrFinishOpenOrdersCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.removeOrFinishOpenOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ReportOrderShortlandedCommand} [reportOrderShortlandedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportShortlandedContainer(reportOrderShortlandedCommand?: ReportOrderShortlandedCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportShortlandedContainer(reportOrderShortlandedCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.reportShortlandedContainer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [from] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async sync(from?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncOrdersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sync(from, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.sync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TestUpdateCustomsStatusCommand} [testUpdateCustomsStatusCommand] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async testUpdateCustomsStatus(testUpdateCustomsStatusCommand?: TestUpdateCustomsStatusCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testUpdateCustomsStatus(testUpdateCustomsStatusCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.testUpdateCustomsStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {CarrierVisitDirection} [direction] 
         * @param {string} [filter] 
         * @param {boolean} [includeCompleted] 
         * @param {string} [orderBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async truckAppointmentOrders(page: number, pageSize: number, direction?: CarrierVisitDirection, filter?: string, includeCompleted?: boolean, orderBy?: string, isDescending?: boolean, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TruckAppointmentOrderDtoPaginatedList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckAppointmentOrders(page, pageSize, direction, filter, includeCompleted, orderBy, isDescending, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.truckAppointmentOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateCustomsStatusCommand} [updateCustomsStatusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomsStatus(updateCustomsStatusCommand?: UpdateCustomsStatusCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomsStatus(updateCustomsStatusCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.updateCustomsStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateReleaseOrdersCommand} [updateReleaseOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrdersReleaseTime(updateReleaseOrdersCommand?: UpdateReleaseOrdersCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrdersReleaseTime(updateReleaseOrdersCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.updateOrdersReleaseTime']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateOrderStowagePositionCommand} [updateOrderStowagePositionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStowagePosition(id: number, updateOrderStowagePositionCommand?: UpdateOrderStowagePositionCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStowagePosition(id, updateOrderStowagePositionCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.updateStowagePosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [containerNumbers] 
         * @param {number} [destinationCarrierVisitId] 
         * @param {CarrierVisitDirection} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateMoveOrdersToCarrierVisitQuery(containerNumbers?: Array<string>, destinationCarrierVisitId?: number, direction?: CarrierVisitDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateMoveOrdersToCarrierVisitQuery(containerNumbers, destinationCarrierVisitId, direction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.validateMoveOrdersToCarrierVisitQuery']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateOrderWeightCommand} [updateOrderWeightCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async weight(id: number, updateOrderWeightCommand?: UpdateOrderWeightCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.weight(id, updateOrderWeightCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.weight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrdersApi - factory interface
 */
export const OrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrdersApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {boolean} [deleteLinkedOrders] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        _delete(id: number, deleteLinkedOrders?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp._delete(id, deleteLinkedOrders, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfirmActualCargoAmountOrderCommand} [confirmActualCargoAmountOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actualCargoAmount(id: number, confirmActualCargoAmountOrderCommand?: ConfirmActualCargoAmountOrderCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.actualCargoAmount(id, confirmActualCargoAmountOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AllowOrderPassageCommand} [allowOrderPassageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allowPassage(allowOrderPassageCommand?: AllowOrderPassageCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.allowPassage(allowOrderPassageCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AllowRestowOrderPassageCommand} [allowRestowOrderPassageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allowRestowPassage(allowRestowOrderPassageCommand?: AllowRestowOrderPassageCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.allowRestowPassage(allowRestowOrderPassageCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateReleaseOrdersCommand} [updateReleaseOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignToRailcar(updateReleaseOrdersCommand?: UpdateReleaseOrdersCommand, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.assignToRailcar(updateReleaseOrdersCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssignOrderToRailcarTrackPositionCommand} [assignOrderToRailcarTrackPositionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignToRailcarTrackPosition(assignOrderToRailcarTrackPositionCommand?: AssignOrderToRailcarTrackPositionCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assignToRailcarTrackPosition(assignOrderToRailcarTrackPositionCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {boolean} [includeRestow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerJourney(filter?: string, includeRestow?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContainerJourneyDto>> {
            return localVarFp.containerJourney(filter, includeRestow, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateOrAssignOrderToRailcarTrackPositionCommand} [createOrAssignOrderToRailcarTrackPositionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrAssignToRailcarTrackPosition(createOrAssignOrderToRailcarTrackPositionCommand?: CreateOrAssignOrderToRailcarTrackPositionCommand, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.createOrAssignToRailcarTrackPosition(createOrAssignOrderToRailcarTrackPositionCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateCustomerSequenceCommand} [updateCustomerSequenceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerSequence(updateCustomerSequenceCommand?: UpdateCustomerSequenceCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.customerSequence(updateCustomerSequenceCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {OrderStatus} [orderStatus] 
         * @param {boolean} [includeCompleted] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveries(filter?: string, orderStatus?: OrderStatus, includeCompleted?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<OrderResponseDto>> {
            return localVarFp.deliveries(filter, orderStatus, includeCompleted, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dropOffOrders(filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<OrderResponseDto>> {
            return localVarFp.dropOffOrders(filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetFirstAvailableOrderInGroupQuery} [getFirstAvailableOrderInGroupQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        firstAvailableOrderInGroups(getFirstAvailableOrderInGroupQuery?: GetFirstAvailableOrderInGroupQuery, options?: RawAxiosRequestConfig): AxiosPromise<Array<FirstAvailableOrderInGroupDto>> {
            return localVarFp.firstAvailableOrderInGroups(getFirstAvailableOrderInGroupQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} referenceNumber 
         * @param {string} operator 
         * @param {number} carrierVisitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookings(referenceNumber: string, operator: string, carrierVisitId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<OrderResponseDto>> {
            return localVarFp.getBookings(referenceNumber, operator, carrierVisitId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} filter 
         * @param {OrderStatus} [status] 
         * @param {boolean} [includeRestow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByContainerNumber(filter: string, status?: OrderStatus, includeRestow?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<OrderResponseDto>> {
            return localVarFp.getByContainerNumber(filter, status, includeRestow, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<OrderResponseDto> {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetOrdersByIdsQuery} [getOrdersByIdsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds(getOrdersByIdsQuery?: GetOrdersByIdsQuery, options?: RawAxiosRequestConfig): AxiosPromise<Array<OrderResponseDto>> {
            return localVarFp.getByIds(getOrdersByIdsQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} filter 
         * @param {CarrierVisitDirection} direction 
         * @param {CarrierType} [carrierType] 
         * @param {OrderStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByReferenceNumber(filter: string, direction: CarrierVisitDirection, carrierType?: CarrierType, status?: OrderStatus, options?: RawAxiosRequestConfig): AxiosPromise<Array<OrderResponseDto>> {
            return localVarFp.getByReferenceNumber(filter, direction, carrierType, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetOrderUpdatesByOrderIdsQuery} [getOrderUpdatesByOrderIdsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadUpdatesByOrderIds(getOrderUpdatesByOrderIdsQuery?: GetOrderUpdatesByOrderIdsQuery, options?: RawAxiosRequestConfig): AxiosPromise<Array<OrderUpdateResponseDto>> {
            return localVarFp.getUnreadUpdatesByOrderIds(getOrderUpdatesByOrderIdsQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MarkOrderUpdatesAsReadCommand} [markOrderUpdatesAsReadCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markOrderUpdatesAsRead(markOrderUpdatesAsReadCommand?: MarkOrderUpdatesAsReadCommand, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.markOrderUpdatesAsRead(markOrderUpdatesAsReadCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {PickUpOrderFilterType} [filterBy] 
         * @param {boolean} [includeRestow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pickUpOrders(filter?: string, filterBy?: PickUpOrderFilterType, includeRestow?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<OrderResponseDto>> {
            return localVarFp.pickUpOrders(filter, filterBy, includeRestow, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateOrdersCommand} [createOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(createOrdersCommand?: CreateOrdersCommand, options?: RawAxiosRequestConfig): AxiosPromise<Array<number>> {
            return localVarFp.post(createOrdersCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateOrderCommand} [updateOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        put(updateOrderCommand?: UpdateOrderCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.put(updateOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {OrderStatus} [orderStatus] 
         * @param {string} [filter] 
         * @param {boolean} [includeCompleted] 
         * @param {string} [orderBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseOrders(page: number, pageSize: number, orderStatus?: OrderStatus, filter?: string, includeCompleted?: boolean, orderBy?: string, isDescending?: boolean, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<ReleaseOrderDtoPaginatedList> {
            return localVarFp.releaseOrders(page, pageSize, orderStatus, filter, includeCompleted, orderBy, isDescending, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RemoveOrFinishOpenOrdersCommand} [removeOrFinishOpenOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOrFinishOpenOrders(removeOrFinishOpenOrdersCommand?: RemoveOrFinishOpenOrdersCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeOrFinishOpenOrders(removeOrFinishOpenOrdersCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportOrderShortlandedCommand} [reportOrderShortlandedCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportShortlandedContainer(reportOrderShortlandedCommand?: ReportOrderShortlandedCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reportShortlandedContainer(reportOrderShortlandedCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [from] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        sync(from?: string, options?: RawAxiosRequestConfig): AxiosPromise<SyncOrdersDto> {
            return localVarFp.sync(from, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TestUpdateCustomsStatusCommand} [testUpdateCustomsStatusCommand] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        testUpdateCustomsStatus(testUpdateCustomsStatusCommand?: TestUpdateCustomsStatusCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.testUpdateCustomsStatus(testUpdateCustomsStatusCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {CarrierVisitDirection} [direction] 
         * @param {string} [filter] 
         * @param {boolean} [includeCompleted] 
         * @param {string} [orderBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        truckAppointmentOrders(page: number, pageSize: number, direction?: CarrierVisitDirection, filter?: string, includeCompleted?: boolean, orderBy?: string, isDescending?: boolean, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<TruckAppointmentOrderDtoPaginatedList> {
            return localVarFp.truckAppointmentOrders(page, pageSize, direction, filter, includeCompleted, orderBy, isDescending, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateCustomsStatusCommand} [updateCustomsStatusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomsStatus(updateCustomsStatusCommand?: UpdateCustomsStatusCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCustomsStatus(updateCustomsStatusCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateReleaseOrdersCommand} [updateReleaseOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrdersReleaseTime(updateReleaseOrdersCommand?: UpdateReleaseOrdersCommand, options?: RawAxiosRequestConfig): AxiosPromise<Array<number>> {
            return localVarFp.updateOrdersReleaseTime(updateReleaseOrdersCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateOrderStowagePositionCommand} [updateOrderStowagePositionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStowagePosition(id: number, updateOrderStowagePositionCommand?: UpdateOrderStowagePositionCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateStowagePosition(id, updateOrderStowagePositionCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [containerNumbers] 
         * @param {number} [destinationCarrierVisitId] 
         * @param {CarrierVisitDirection} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateMoveOrdersToCarrierVisitQuery(containerNumbers?: Array<string>, destinationCarrierVisitId?: number, direction?: CarrierVisitDirection, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.validateMoveOrdersToCarrierVisitQuery(containerNumbers, destinationCarrierVisitId, direction, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateOrderWeightCommand} [updateOrderWeightCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weight(id: number, updateOrderWeightCommand?: UpdateOrderWeightCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.weight(id, updateOrderWeightCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrdersApi - object-oriented interface
 */
export class OrdersApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {boolean} [deleteLinkedOrders] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public _delete(id: number, deleteLinkedOrders?: boolean, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration)._delete(id, deleteLinkedOrders, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ConfirmActualCargoAmountOrderCommand} [confirmActualCargoAmountOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public actualCargoAmount(id: number, confirmActualCargoAmountOrderCommand?: ConfirmActualCargoAmountOrderCommand, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).actualCargoAmount(id, confirmActualCargoAmountOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AllowOrderPassageCommand} [allowOrderPassageCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public allowPassage(allowOrderPassageCommand?: AllowOrderPassageCommand, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).allowPassage(allowOrderPassageCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AllowRestowOrderPassageCommand} [allowRestowOrderPassageCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public allowRestowPassage(allowRestowOrderPassageCommand?: AllowRestowOrderPassageCommand, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).allowRestowPassage(allowRestowOrderPassageCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateReleaseOrdersCommand} [updateReleaseOrdersCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assignToRailcar(updateReleaseOrdersCommand?: UpdateReleaseOrdersCommand, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).assignToRailcar(updateReleaseOrdersCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssignOrderToRailcarTrackPositionCommand} [assignOrderToRailcarTrackPositionCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assignToRailcarTrackPosition(assignOrderToRailcarTrackPositionCommand?: AssignOrderToRailcarTrackPositionCommand, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).assignToRailcarTrackPosition(assignOrderToRailcarTrackPositionCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filter] 
     * @param {boolean} [includeRestow] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public containerJourney(filter?: string, includeRestow?: boolean, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).containerJourney(filter, includeRestow, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateOrAssignOrderToRailcarTrackPositionCommand} [createOrAssignOrderToRailcarTrackPositionCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createOrAssignToRailcarTrackPosition(createOrAssignOrderToRailcarTrackPositionCommand?: CreateOrAssignOrderToRailcarTrackPositionCommand, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).createOrAssignToRailcarTrackPosition(createOrAssignOrderToRailcarTrackPositionCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateCustomerSequenceCommand} [updateCustomerSequenceCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public customerSequence(updateCustomerSequenceCommand?: UpdateCustomerSequenceCommand, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).customerSequence(updateCustomerSequenceCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filter] 
     * @param {OrderStatus} [orderStatus] 
     * @param {boolean} [includeCompleted] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deliveries(filter?: string, orderStatus?: OrderStatus, includeCompleted?: boolean, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).deliveries(filter, orderStatus, includeCompleted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dropOffOrders(filter?: string, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).dropOffOrders(filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetFirstAvailableOrderInGroupQuery} [getFirstAvailableOrderInGroupQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public firstAvailableOrderInGroups(getFirstAvailableOrderInGroupQuery?: GetFirstAvailableOrderInGroupQuery, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).firstAvailableOrderInGroups(getFirstAvailableOrderInGroupQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} referenceNumber 
     * @param {string} operator 
     * @param {number} carrierVisitId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBookings(referenceNumber: string, operator: string, carrierVisitId: number, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).getBookings(referenceNumber, operator, carrierVisitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} filter 
     * @param {OrderStatus} [status] 
     * @param {boolean} [includeRestow] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getByContainerNumber(filter: string, status?: OrderStatus, includeRestow?: boolean, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).getByContainerNumber(filter, status, includeRestow, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getById(id: number, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetOrdersByIdsQuery} [getOrdersByIdsQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getByIds(getOrdersByIdsQuery?: GetOrdersByIdsQuery, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).getByIds(getOrdersByIdsQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} filter 
     * @param {CarrierVisitDirection} direction 
     * @param {CarrierType} [carrierType] 
     * @param {OrderStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getByReferenceNumber(filter: string, direction: CarrierVisitDirection, carrierType?: CarrierType, status?: OrderStatus, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).getByReferenceNumber(filter, direction, carrierType, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetOrderUpdatesByOrderIdsQuery} [getOrderUpdatesByOrderIdsQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUnreadUpdatesByOrderIds(getOrderUpdatesByOrderIdsQuery?: GetOrderUpdatesByOrderIdsQuery, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).getUnreadUpdatesByOrderIds(getOrderUpdatesByOrderIdsQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MarkOrderUpdatesAsReadCommand} [markOrderUpdatesAsReadCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public markOrderUpdatesAsRead(markOrderUpdatesAsReadCommand?: MarkOrderUpdatesAsReadCommand, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).markOrderUpdatesAsRead(markOrderUpdatesAsReadCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filter] 
     * @param {PickUpOrderFilterType} [filterBy] 
     * @param {boolean} [includeRestow] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public pickUpOrders(filter?: string, filterBy?: PickUpOrderFilterType, includeRestow?: boolean, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).pickUpOrders(filter, filterBy, includeRestow, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateOrdersCommand} [createOrdersCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public post(createOrdersCommand?: CreateOrdersCommand, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).post(createOrdersCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateOrderCommand} [updateOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public put(updateOrderCommand?: UpdateOrderCommand, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).put(updateOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {OrderStatus} [orderStatus] 
     * @param {string} [filter] 
     * @param {boolean} [includeCompleted] 
     * @param {string} [orderBy] 
     * @param {boolean} [isDescending] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public releaseOrders(page: number, pageSize: number, orderStatus?: OrderStatus, filter?: string, includeCompleted?: boolean, orderBy?: string, isDescending?: boolean, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).releaseOrders(page, pageSize, orderStatus, filter, includeCompleted, orderBy, isDescending, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RemoveOrFinishOpenOrdersCommand} [removeOrFinishOpenOrdersCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeOrFinishOpenOrders(removeOrFinishOpenOrdersCommand?: RemoveOrFinishOpenOrdersCommand, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).removeOrFinishOpenOrders(removeOrFinishOpenOrdersCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportOrderShortlandedCommand} [reportOrderShortlandedCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportShortlandedContainer(reportOrderShortlandedCommand?: ReportOrderShortlandedCommand, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).reportShortlandedContainer(reportOrderShortlandedCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [from] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public sync(from?: string, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).sync(from, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TestUpdateCustomsStatusCommand} [testUpdateCustomsStatusCommand] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public testUpdateCustomsStatus(testUpdateCustomsStatusCommand?: TestUpdateCustomsStatusCommand, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).testUpdateCustomsStatus(testUpdateCustomsStatusCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {CarrierVisitDirection} [direction] 
     * @param {string} [filter] 
     * @param {boolean} [includeCompleted] 
     * @param {string} [orderBy] 
     * @param {boolean} [isDescending] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public truckAppointmentOrders(page: number, pageSize: number, direction?: CarrierVisitDirection, filter?: string, includeCompleted?: boolean, orderBy?: string, isDescending?: boolean, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).truckAppointmentOrders(page, pageSize, direction, filter, includeCompleted, orderBy, isDescending, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateCustomsStatusCommand} [updateCustomsStatusCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCustomsStatus(updateCustomsStatusCommand?: UpdateCustomsStatusCommand, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).updateCustomsStatus(updateCustomsStatusCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateReleaseOrdersCommand} [updateReleaseOrdersCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateOrdersReleaseTime(updateReleaseOrdersCommand?: UpdateReleaseOrdersCommand, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).updateOrdersReleaseTime(updateReleaseOrdersCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UpdateOrderStowagePositionCommand} [updateOrderStowagePositionCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateStowagePosition(id: number, updateOrderStowagePositionCommand?: UpdateOrderStowagePositionCommand, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).updateStowagePosition(id, updateOrderStowagePositionCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [containerNumbers] 
     * @param {number} [destinationCarrierVisitId] 
     * @param {CarrierVisitDirection} [direction] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateMoveOrdersToCarrierVisitQuery(containerNumbers?: Array<string>, destinationCarrierVisitId?: number, direction?: CarrierVisitDirection, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).validateMoveOrdersToCarrierVisitQuery(containerNumbers, destinationCarrierVisitId, direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UpdateOrderWeightCommand} [updateOrderWeightCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public weight(id: number, updateOrderWeightCommand?: UpdateOrderWeightCommand, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).weight(id, updateOrderWeightCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

